import React, { useState } from "react"
import { toast } from "react-toastify"
import Input from "./../Inputt"

import { apiCall, getOfflineToken } from './../../../Helper'
import { useEffect } from "react"

export default ({ setIsLoading, updateInfo }) => {
  const [user, setUser] = useState({})

  const [mobile, setMobile] = useState('')
  const [code, setCode] = useState('')

  const [show, setShow] = useState(false)

  useEffect(() => {
    apiCall({ url: '/user/userInfo' }).then(info => {
      setUser(info.data)
      setShow(!info.data.mobile_validated)
    })
  }, [])

  function resendCode() {
    setIsLoading(true)
    apiCall({
      url: '/user/mobileValidate',
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        if (res.data.code === 0) {
          toast.success('کد دوباره ارسال شد')
          setCode('')
        } else toast.error(res.data.msg || 'مشکل در سیستم')
      } else toast.error('مشکل در سیستم')
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }
  function confirmCode() {
    if (code) {
      setIsLoading(true)
      apiCall({
        url: '/user/mobileValidate',
        method: 'post',
        data: { code }
      }).then(res => {
        setIsLoading(false)
        if (res && res.data) {
          if (res.data.code === 0) {
            apiCall({ url: '/user/userInfo' }).then(info => {
              typeof localStorage !== 'undefined' && localStorage.setItem("user", JSON.stringify({ token: getOfflineToken().token, ...info.data }))
            })
            toast.success('ثبت موبایل با موفقیت انجام شد')
            setTimeout(() => {
              typeof window !== 'undefined' && window.location.reload()
            }, 1000);
          } else toast.error(res.data.msg || 'مشکل در سیستم')
        } else toast.error('مشکل در سیستم')
      }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
    } else {
      toast.warn('لطفا اطلاعات را وارد کنید')
    }
  }

  return (
    show ? <div className={`modal flexed fl-c full`}>
      <div className={`p-45 bg-top-nav w-40 shadow-mild radius-8 popIn`}>
        <h3 className="m-0 text-shadow font-16 px-8">
          {!user.mobile && 'ثبت و '}
          تایید شماره موبایل</h3>
        <hr className="mb-0" />
        <div className="px-32 pt-24 pb-16 modal-content">

          {!user.mobile ? <Input className="bg-light blocked mt-24" inputClassName="ltr" type="text" lbl="** ** *** **9"
            placeholder="شماره موبایل:" onChange={e => {
              if (e.target.value[0] !== '0')
                setMobile(e.target.value.length <= 10 ? e.target.value.replace(/\D/g, "") : mobile)
            }}
            onKeyDown={e => {
              if (e.keyCode === 13)
                mobile ? updateInfo(mobile) : toast.warn('لطفا اطلاعات را وارد کنید')
            }} value={mobile} /> :
            <div>
              کد به شماره
              &nbsp;
              <span>{user.mobile || '--'}</span>
              &nbsp;
              ارسال شد
            </div>
          }

          {user.mobile && <> <Input className="bg-light blocked mt-24" type="text"
            placeholder="کد تایید:" onChange={e => {
              if (e.target.value[0] !== '0')
                setCode(e.target.value.length <= 5 ? e.target.value.replace(/\D/g, "") : code)
            }}
            onKeyDown={e => {
              if (e.keyCode === 13)
                confirmCode()
            }} value={code} />

            <div className="mt-8">
              <button className="font-9 bg-none bd-none iran-sans" onClick={resendCode}>ارسال مجدد کد</button>
            </div>
          </>}

        </div>
        <div className="ltr mt-32 px-8">
          <button className="bd-none bg-tomato iran-sans radius-4 font-10 text-top-nav"
            style={{ width: 85, padding: '5px 0' }} onClick={() => {
              if (!user.mobile)
                mobile ? updateInfo(mobile) : toast.warn('لطفا اطلاعات را وارد کنید')
              else
                confirmCode()
            }}>
            ثبت</button>
          <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
            onClick={() => setShow(false)}
            style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}>بعدا</button>
        </div>
      </div>
    </div> : <div></div>
  )
}
